import { FC } from 'react';
import { useSelector } from 'react-redux';
// import SettingsIcon from '@material-ui/icons/Settings';
import { useMediaQuery, Theme, Box, makeStyles, Typography, Divider } from '@material-ui/core';
import {
    useTranslate,
    // DashboardMenuItem,
    MenuItemLink,
    MenuProps,
    usePermissions,
    Logout,
} from 'react-admin';
import clsx from 'clsx';

// import merchant from '../merchants';
// import financing from '../financings';
// import transactions from '../transactions';
// import platforms from '../platforms';
// import financialRegimens from '../financialRegimens';

// import SubMenu from './SubMenu';
import { AppState } from '../types';
import Logo from './Logo';

import { adminViewsRoles, merchantViewRoles, partnerRoles } from '../utils/roles'

// type MenuName = 'menuMerchants' | 'menuCatalog' | 'menuSales' | 'menuCustomers';

const Menu: FC<MenuProps> = ({ dense = false }) => {
    const { permissions, loaded } = usePermissions();
    // const [state, setState] = useState({
    //     menuCatalog: true,
    //     menuSales: true,
    //     menuCustomers: true,
    //     menuMerchants: true,
    // });
    const classes = useStyles()
    const translate = useTranslate();

    const isXSmall = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('xs')
    );
    const isSmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );

    const open = useSelector((state: AppState) => state.admin.ui.sidebarOpen);
    useSelector((state: AppState) => state.theme); // force rerender on theme change

    // const handleToggle = (menu: MenuName) => {
    //     setState(state => ({ ...state, [menu]: !state[menu] }));
    // };

    return (
        <div
            className={clsx(classes.root, open ? classes.open : classes.closed)}
            role="menu"
        >
            {' '}
            {isSmall &&
                <Box className={classes.logo}>
                    <Logo />
                </Box>
            }
            {/* <DashboardMenuItem onClick={onMenuClick} sidebarIsOpen={open} /> */}
            <MenuItemLink
                to="/"
                primaryText={translate('resources.common.fields.home')}
                leftIcon={<Typography>{translate('resources.common.fields.home_letter')}</Typography>}
                dense={dense}
                exact
            />
            {loaded && adminViewsRoles.includes(permissions.defaultRole) && <>
                {/* <SubMenu
                    handleToggle={() => handleToggle('menuMerchants')}
                    isOpen={state.menuMerchants}
                    sidebarIsOpen={open}
                    name="pos.menu.Merchant"
                    icon={<merchant.icon />}
                    dense={dense}
                > */}
                <MenuItemLink
                    to={`/Merchant`}
                    primaryText={translate(`resources.Merchant.name`, {
                        smart_count: 2,
                    })}
                    // leftIcon={<merchant.icon />}
                    leftIcon={<Typography>{translate('resources.common.fields.Merchant_letter')}</Typography>}
                    dense={dense}
                />
                {/* </SubMenu> */}
                <MenuItemLink
                    to={`/Financing`}
                    primaryText={translate(`resources.Financing.name`, {
                        smart_count: 2,
                    })}
                    // leftIcon={<financing.icon />}
                    leftIcon={<Typography>{translate('resources.common.fields.Financing_letter')}</Typography>}
                    dense={dense}
                />
                <MenuItemLink
                    to={`/Platform`}
                    primaryText={translate(`resources.Platform.name`, {
                        smart_count: 2,
                    })}
                    // leftIcon={<platforms.icon />}
                    leftIcon={<Typography>{translate('resources.common.fields.Platform_letter')}</Typography>}
                    dense={dense}
                />
                <MenuItemLink
                    to={`/Transaction`}
                    primaryText={translate(`resources.Transaction.name`, {
                        smart_count: 2,
                    })}
                    // leftIcon={<transactions.icon />}
                    leftIcon={<Typography>{translate('resources.common.fields.Transaction_letter')}</Typography>}
                    dense={dense}
                />
                <MenuItemLink
                    to={`/FinancialRegimen`}
                    primaryText={translate(`resources.FinancialRegimen.name`, {
                        smart_count: 2,
                    })}
                    // leftIcon={<financialRegimens.icon />}
                    leftIcon={<Typography>{translate('resources.common.fields.FinancialRegimen_letter')}</Typography>}
                    dense={dense}
                />
                <Divider variant="inset" className={classes.sep} />
                <Typography variant="h6" className={classes.title}>{"CLIP:"}</Typography>
                <MenuItemLink
                    to={`/Offers`}
                    primaryText={translate(`resources.offers.name`, {
                        smart_count: 2,
                    })}
                    // leftIcon={<offers.icon />}
                    leftIcon={<Typography>{translate('resources.common.fields.offers_letter')}</Typography>}
                    dense={dense}
                />
                <MenuItemLink
                    to={`/merchants`}
                    primaryText={translate(`resources.merchants.name`, {
                        smart_count: 2,
                    })}
                    // leftIcon={<merchants.icon />}
                    leftIcon={<Typography>{translate('resources.common.fields.merchants_letter')}</Typography>}
                    dense={dense}
                />
                <MenuItemLink
                    to={`/financings`}
                    primaryText={translate(`resources.financings.name`, {
                        smart_count: 2,
                    })}
                    // leftIcon={<financings.icon />}
                    leftIcon={<Typography>{translate('resources.common.fields.financings_letter')}</Typography>}
                    dense={dense}
                />
                <MenuItemLink
                    to={`/collections`}
                    primaryText={translate(`resources.collections.name`, {
                        smart_count: 2,
                    })}
                    // leftIcon={<collections.icon />}
                    leftIcon={<Typography>{translate('resources.common.fields.collections_letter')}</Typography>}
                    dense={dense}
                />
            </>}
            {loaded && merchantViewRoles.includes(permissions.defaultRole) && <></>}

            {loaded && partnerRoles.includes(permissions.defaultRole) && <>
                <MenuItemLink
                    to={`/Merchant`}
                    primaryText={translate(`resources.Merchant.name`, {
                        smart_count: 2,
                    })}
                    // leftIcon={<merchant.icon />}
                    leftIcon={<Typography>{translate('resources.common.fields.Merchant_letter')}</Typography>}
                    dense={dense}
                />
                {/* </SubMenu> */}
                <MenuItemLink
                    to={`/Financing`}
                    primaryText={translate(`resources.Financing.name`, {
                        smart_count: 2,
                    })}
                    // leftIcon={<financing.icon />}
                    leftIcon={<Typography>{translate('resources.common.fields.Financing_letter')}</Typography>}
                    dense={dense}
                />
            </>}
            {isXSmall && (
                <MenuItemLink
                    to="/configuration"
                    primaryText={translate('pos.configuration')}
                    // leftIcon={<SettingsIcon />}
                    dense={dense}
                />
            )}
            {isXSmall && <Logout button={true} className={classes.logout} />}
        </div>
    );
};

const useStyles = makeStyles(theme => ({
    root: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    open: {
        width: 200,
        '& .MuiListItemIcon-root': {
            display: 'none'
        }
    },
    title: {
        marginLeft: theme.spacing(2),
    },
    sep: {
        // width: '100%',
        height: '2px',
        backgroundColor: theme.palette.grey[500],
        marginLeft: theme.spacing(2),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    closed: {
        width: 55,
    },
    logo: {
        margin: '1em',
    },
    logout: {
        // fontWeight: 'bold'
    }
}));

export default Menu;
